define('main_head',[
	'backbone'
], function (Backbone) {

	/*
	 * View for the mighty header
	**/
	return Backbone.View.extend({

		// view : Tmpl['main_head.hbs']
		view : false

		, initialize : function initialize(opts) {
            this.opts = opts || {};
			this.view = this.opts.view;
			// console.log('... Render Part Head');
			this.render();
		}

		, render : function render() {

			// return this.$el.html(Mustache.render(this.tmpl, BB.site_header));
			// console.log('this.tmpl: '+this.tmpl);
			// return this.$el.html(Mustache.render(this.tmpl, BB.site_header));

			return this.$el.html(this.view(this.opts.data));
		}

	});

});
